module.exports = __webpack_public_path__ + "img/argdown-mark.2d95ea1a.svg";